export const gestureKeys = {
    GESTURE_MSG: 'GESTURE_MSG',
    REVERT_GESTURE_MSG: 'REVERT_GESTURE_MSG',
    CONTROL_BAR_GESTURE: 'CONTROL_BAR_GESTURE',
    HOTKEY_GESTURE: 'HOTKEY_GESTURE',
    TEACHER_ACKNOWLEDGEMENT: 'TEACHER_ACKNOWLEDGEMENT',
}
